// Link de notificação que abre um serviço: no Painel Logístico a OS abre ali
// mesmo, em vez de levar o operador para a Listagem.
const SERVICO_NA_LISTA = /^\/services(?:\/list)?\?(?:edit|service_id)=([^&]+)(.*)$/;

export function destinoDoServico(link, pathname) {
  if (!link || !pathname?.startsWith("/services/logistics")) return link;
  const m = SERVICO_NA_LISTA.exec(link);
  return m ? `/services/logistics?edit=${m[1]}${m[2] || ""}` : link;
}
